import {BaseApi} from "@/core/api/base.api";
import {Room} from '@/core/api/room.api'
import {groupService} from '@/core/service/group.service'
import _ from "lodash"

class GroupApi extends BaseApi {
    #groupData

    constructor() {
        super()
    }

    async setGroupInfo(groupId) {
        if(!groupId) return;
        let { data } = await groupService.getGroup(groupId)
        this.#groupData = data
        Room.emit({
            type: 'group_data_init',
            data: _.cloneDeep(data)
        })
    }
    
    getGroupData(){
        return this.#groupData;
    }
}

export const groupApi = new GroupApi();